<script lang="ts" setup>
import { UserToCreate } from '../NewUser/useCreateMultipleUsers';
import { useLocale } from '../../composables/useLocale';
import GroupAssignment from '../../el/NewUser/GroupAssignment.vue';

type Props = {
  user: UserToCreate;
  disabled: boolean;
  organizationUid: string;
};

const props = defineProps<Props>();

type Emits = {
  (e: 'update', userKey: string, value: string | undefined): void;
};

const emit = defineEmits<Emits>();

const { t } = useLocale();

const model = defineModel<string | undefined>();

const onModelUpdate = () => {
  emit('update', props.user.key, model.value);
};

defineExpose({
  isValid: () => !!model.value,
});
</script>

<template>
  <v-row>
    <v-col>
      <h4>
        {{ t('lcp.group_required') }}
      </h4>
      <p>{{ t('lcp.required_group_info') }}</p>
    </v-col>
  </v-row>
  <v-row class="mt-3">
    <v-col>
      <GroupAssignment
        :organization-uid="organizationUid"
        v-model:model-value="model"
        :required="true"
        :label="`${t('lcp.group')} *`"
        variant="field"
        @groupSelected="onModelUpdate"
      >
      </GroupAssignment>
    </v-col>
  </v-row>
</template>
